import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StudentInfo from '../StudentInfo';
import './style.scss';

export default class RequestedUser extends Component {
  state = {
    fullReason: false
  }

  render() {
    const { requestedUser, openPopupChooseStudent, eventId, openPopupViewStudentProfile, isOfferEvent } = this.props;

    return (
      <div className="requested-user-wrapper">
        <div className="requested-user">
          <div className="requested-user-info-container">
            <div className="requested-user-info" onClick={openPopupViewStudentProfile}>
              <StudentInfo student={requestedUser} size="large" />
            </div>
          </div>

          <div className="reason">
            <img alt="" src="/images/requested-user-reason.svg" />
            <div
              className={this.state.fullReason ? 'mh-36' : 'ellipsis'}
              onClick={() => this.setState({ fullReason: true })}
            >
              <div>{requestedUser.reason}</div>
            </div>
          </div>
        </div>
        {!isOfferEvent && (
          <div className="action">
            <div
              className="deny"
              onClick={() => openPopupChooseStudent('deny', eventId, requestedUser.objectId)}
            />
            <div
              className="accept"
              onClick={() => openPopupChooseStudent('accept', eventId, requestedUser.objectId)}
            />
          </div>
        )}
      </div>
    );
  }
}

RequestedUser.propTypes = {
  requestedUser: PropTypes.object,
  openPopupChooseStudent: PropTypes.func,
  openPopupViewStudentProfile: PropTypes.func,
  eventId: PropTypes.string,
  isOfferEvent: PropTypes.bool
};